import { WORKFLOWS_ACTION_MESSAGES_TYPES } from 'src/pages/ConfigurationPage/WorkflowsTab/constants';
import type {
  WorkflowAction,
  WorkflowFormAction,
} from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';

// The data-collection fields the action asks the customer for, in display order.
const getCollectedFields = (data: Partial<WorkflowFormAction>): WorkflowAction['fields'] => {
  const fields: WorkflowAction['fields'] = [];

  if (data.action_fields_name) {
    fields.push({
      type: 'name',
    });
  }

  if (data.action_fields_email) {
    fields.push({
      type: 'email',
    });
  }

  if (data.action_fields_phone_number) {
    fields.push({
      type: 'phone_number',
    });
  }

  if (data.action_fields_custom && data.action_fields_custom_array?.length) {
    data.action_fields_custom_array.forEach((field) => {
      fields.push({
        type: 'custom',
        ...field,
      });
    });
  }

  return fields;
};

const applyForwardToEmail = (action: WorkflowAction, data: Partial<WorkflowFormAction>) => {
  action.message_type = data.action_message_type;

  if (data.sender_name !== undefined) {
    action.sender_name = data.sender_name;
  }

  if (data.subject !== undefined) {
    action.subject = data.subject;
  }

  if (data.sender_email_address !== undefined) {
    action.sender_email_address = data.sender_email_address;
  }

  action.receiver_email_addresses = data.receiver_email_addresses
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

/** Maps one action's form values back to the stored workflow action. */
export const getWorkflowRequestAction = (data: Partial<WorkflowFormAction>): WorkflowAction => {
  const action: WorkflowAction = {
    type: data.action_type === 'escalate' ? data.action_escalated_list : data.action_type,
  };

  if (action.type === 'handle_with_crm') {
    return action;
  }

  if (WORKFLOWS_ACTION_MESSAGES_TYPES.includes(action.type)) {
    action.message = data.action_message;

    return action;
  }

  if (action.type === 'close') {
    action.message = data.message_close;

    return action;
  }

  if (['collect_and_escalate', 'forward_to_email'].includes(action.type)) {
    action.message_before = data.message_before;
    action.message_after = data.message_after;
    action.fields = getCollectedFields(data);

    if (action.type === 'forward_to_email') {
      applyForwardToEmail(action, data);
    }

    return action;
  }

  return action;
};
